import { useSelector } from 'react-redux';
import { ApplicationPath } from '../../ecg/types/application-path.types';
import { Metrics } from '../../resting/Metrics';
import { ShrMetrics } from '../components/ShrMetrics';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';

export const useMetrics = (path: ApplicationPath | null) => {
  const withComputedMetrics = useSelector(
    getLayoutValueSelector('withComputedMetrics'),
  );

  const metricsLayout = withComputedMetrics ? 'resting' : path;
  switch (metricsLayout) {
    case 'resting':
      return <Metrics />;
    default:
      return <ShrMetrics />;
  }
};
